import axiosInstance from "axiosConfig";
import { CompanyType } from "types/CompanyTypes";

const searchCompaniesFetcher = async function searchCompaniesFetcher(
  q: string,
  origin?: "reliance" | "other",
  status?: "active" | "withdrawn" | "hidden"
): Promise<CompanyType[]> {
  const query = (q || "").trim();
  const res = await axiosInstance.get(`/companies/search`, {
    params: {
      q: query,
      origin,
      status,
    },
  });
  return res.data as CompanyType[];
}


export default searchCompaniesFetcher;